import React, { Suspense } from "react";
import { Box, CircularProgress } from "@mui/material";

// Plotly is loaded on demand (same chunk as the other 3D plots).
const LabGamutPlotInner = React.lazy(() => import("./LabGamutPlotInner"));

/** See LabGamutPlotInner for the props. */
export default function LabGamutPlot(props) {
    const height = props.height ?? 480;
    return (
        <Suspense
            fallback={
                <Box sx={{ height, display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <CircularProgress size={28} thickness={4} aria-label="Loading the 3D gamut" />
                </Box>
            }
        >
            <LabGamutPlotInner {...props} />
        </Suspense>
    );
}
